import axios from 'axios';
import { getApiEndpoint } from '@/utils/ERPUtils';

/**
 * Post-login landing route.
 *
 * Admins on a workspace whose initial setup is incomplete (company name,
 * website, contact number, email address, or no AI provider key) land on
 * the Customise page so they finish configuration first. Everyone else -
 * and any failure of the check - lands on the dashboard as normal.
 */
/**
 * Cross-component signal fired after any save that can change setup
 * completeness (Customise form, provider keys, email account). The sidebar
 * listens and refetches so the setup lock lifts without a page reload.
 */
export const SETUP_STATUS_EVENT = 'orgain:setup-status-changed';

export const notifySetupStatusChanged = (): void => {
  window.dispatchEvent(new Event(SETUP_STATUS_EVENT));
};

export const resolvePostLoginRoute = async (): Promise<string> => {
  try {
    const res = await axios.get(getApiEndpoint('GET_SETUP_STATUS'), { withCredentials: true });
    const status = res.data?.message;
    if (status && status.can_configure && !status.complete) {
      return '/dashboard/admin/company';
    }
  } catch {
    /* fail open - never block login on the setup check */
  }
  return '/dashboard';
};
